// extracted by mini-css-extract-plugin
module.exports = {"sortableBlockList":"sortableBlockList--3-6e3V7qWN","disabled":"disabled--1OwSNMmjTV"};